import { promisedGetBase64, promisedImgFromBase64 } from 'helpers'
import * as ERRORS from 'app/validators/base/constants'
import imageNameNormalizer from 'helpers/imageNameNormalizer'

type Params = {
  mimes: string[],
  minSize: any,
  maxSize: any,
  file: File,
  organizations: any,
  activitiesImages: any,
}

export default async function validateImage({
  mimes,
  minSize,
  maxSize,
  file,
  organizations,
  activitiesImages,
}: Params): Promise<void | string> {
  if (!~mimes.indexOf(file.type)) {
    return ERRORS.WRONG_FILE_TYPE
  }
  const base64String = await promisedGetBase64(file)
  const img = await promisedImgFromBase64(base64String)
  if (minSize != null && (img.naturalWidth < minSize.width || img.naturalHeight < minSize.height)) {
    return ERRORS.IMAGE_TOO_SMALL
  }
  if (maxSize != null && (img.naturalWidth > maxSize.width || img.naturalHeight > maxSize.height)) {
    return ERRORS.IMAGE_TOO_BIG
  }
  if (!!organizations && file.name) {
    if (file.name.indexOf('__') === -1) {
      return ERRORS.WRONG_FORMAT_IMAGE_NAME
    }
    const imageDomain = file.name.split('__')[0]
    const isDomainExist = organizations.find(
      (organization: Map<string, any>) => organization.get('domain') === imageDomain
    )
    if (isDomainExist === undefined) {
      return ERRORS.UNKNOWN_DOMAIN
    }
    const normalizeFileName = imageNameNormalizer(file.name)
    const imageExist = activitiesImages.find((image: Map<string, any>) => image.get('fileName') === normalizeFileName)
    if (imageExist !== undefined) {
      return ERRORS.IMAGE_ALREADY_EXIST
    }
  }
}
